<template>
  <div class="container pt-2 pt-md-4 page-content">
    <div class="row">
      <div class="col-12">
        <h1>TIM Finanças</h1>
        <p>Quem nunca sonhou em montar o próprio negócio, mas tem dificuldade até de administrar a própria vida financeira? Seja numa situação de desemprego, seja pela vontade de ser patrão de si mesmo, acredite, todo mundo já teve ou tem dificuldade de gerenciar seu dinheiro.</p>
        <p>Mas, daí surgem as seguintes questões: por onde devo começar? Se não consigo administrar a minha vida financeira, com que dinheiro investir na abertura ou manutenção do meu próprio negócio? Ou ainda: é possível investir ou poupar em momentos de crise? Como saber para onde estão indo os meus gastos? Se você, assim como milhares de pessoas, já sonhou em abrir o próprio negócio, em aprimorar os seus conhecimentos sobre empreendedorismo ou, simplesmente, quer ter controle das suas finanças pessoais, para conseguir fazer pequenos ou grandes investimentos, apresentamos o TIM finanças.</p>
        <p>Com ele, você terá em suas mãos dicas, podcasts, vídeos e notícias que vão auxiliá-lo a gerenciar melhor suas finanças pessoais, abrir e administrar o seu próprio negócio, e desenvolver competências que irão fazer a diferença no seu dia-a-dia.</p>
        <p>São centenas de conteúdo disponíveis para você acessar quando e onde que quiser.</p>
        <p>O Serviço possui elementos de gamificação que tornam o aprendizado mais divertido e oferece temas relacionados a finanças pessoais, empreendedorismo, plano de negócios, gestão de pequenas empresas, técnicas de negociação e vendas, entre outros. Você também ficará informado sobre os principais assuntos de economia.</p>
        <p>Leia os textos com os conteúdos e dicas, assista os vídeos e teste seus conhecimentos sobre Finanças já. Faça o download do aplicativo e experimente grátis.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about"
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/globals.scss";
.page-content {
  h1 {
    font-size: 2.5rem;
    font-weight: bold;
    color: #003c63;
    margin-bottom: 27px;
    margin-top: 52px;
  }
  h2 {
    font-size: 1.25rem;
    font-weight: bold;
    color: #343434;
    margin-bottom: 15px;
  }
  p,
  li {
    font-weight: 500;
    color: #343434;
  }
}
</style>



// WEBPACK FOOTER //
// About.vue?de4b6f20